// extracted by mini-css-extract-plugin
export default {"greyText":"ViewPanel_greyText__CsgG9","offsetItem":"ViewPanel_offsetItem__-Ix7O","specialHours":"ViewPanel_specialHours__RGcMU","dateLabel":"ViewPanel_dateLabel__m1kmI"};